"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _companies = require("@/api/master/companies");
var _common = require("@/api/common");
var _vueAdvancedCropper = require("vue-advanced-cropper");
require("vue-advanced-cropper/dist/style.css");
var _index = _interopRequireDefault(require("@/components/FileUpload/index.vue"));
var _states = require("@/api/master/states");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, _companies.defaultCompanyData);
    this.loading = false;
    this.states = [];
    this.rules = {
      name: [{
        required: true,
        message: 'Company name required',
        trigger: 'blur'
      }],
      gstNumber: [{
        validator: this.validateGST,
        trigger: 'blur'
      }],
      panNumber: [{
        validator: this.validatePAN,
        trigger: 'blur'
      }]
    };
    this.cropperVisible = false;
    this.imageSrc = '';
    this.selectedFile = null;
    this.brochureUploading = false;
    this.logo = [];
    this.image = {
      src: '',
      type: ''
    };
    this.logoUrl = '';
  }
  validateGST(rule, value, callback) {
    if (!value) return callback(); // allow empty
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (!gstRegex.test(value)) {
      callback(new Error('Invalid GST format'));
    } else {
      callback();
    }
  }
  async fetchStates() {
    try {
      const res = await (0, _states.getStates)({
        limit: 1000,
        sort: 'name,ASC'
      });
      this.states = res;
    } catch (error) {
      console.error('Failed to fetch states', error);
    }
  }
  validatePAN(rule, value, callback) {
    if (!value) return callback(); // allow empty
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (!panRegex.test(value)) {
      callback(new Error('Invalid PAN format'));
    } else {
      callback();
    }
  }
  handleGSTChange(value) {
    if (value && value.length >= 12) {
      this.formData.panNumber = value.substring(2, 12).toUpperCase();
    } else {
      this.formData.panNumber = '';
    }
  }
  // 1️⃣ When user selects file
  onFileSelected(event) {
    const file = event.target.files[0];
    if (!file) return;
    this.selectedFile = file;
    const reader = new FileReader();
    reader.onload = e => {
      this.imageSrc = e.target.result;
      this.cropperVisible = true;
    };
    reader.readAsDataURL(file);
  }
  // 2️⃣ Crop image
  cropImage() {
    const cropper = this.$refs.cropper;
    const canvas = cropper.getResult().canvas;
    canvas.toBlob(async blob => {
      var _this$selectedFile;
      const formData = new FormData();
      formData.append('file', blob, (_this$selectedFile = this.selectedFile) === null || _this$selectedFile === void 0 ? void 0 : _this$selectedFile.name);
      const response = await (0, _common.uploadFile)(formData);
      this.formData.logo = response;
      this.cropperVisible = false;
    }, 'image/png');
  }
  triggerFileInput() {
    this.$refs.fileInput.click();
  }
  triggerBrochureInput() {
    this.$refs.brochureInput.click();
  }
  get brochureFileName() {
    if (!this.formData.broucherUrl) return '';
    const parts = this.formData.broucherUrl.split('/');
    return parts[parts.length - 1];
  }
  openBrochure() {
    window.open(this.formData.broucherUrl, '_blank');
  }
  async onBrochureSelected(event) {
    const file = event.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    try {
      this.brochureUploading = true;
      const response = await (0, _common.uploadFile)(formData);
      this.formData.broucherUrl = response;
    } finally {
      this.brochureUploading = false;
      event.target.value = '';
    }
  }
  created() {
    this.fetchStates();
    if (this.isEdit) {
      const id = this.$route.params.id;
      this.fetchData(+id);
    }
  }
  addMobile() {
    this.formData.mobileNumbers.push('');
  }
  removeMobile(index) {
    this.formData.mobileNumbers.splice(index, 1);
  }
  async fetchData(id) {
    const data = await (0, _companies.getCompanyById)(id);
    Object.keys(this.formData).forEach(key => {
      this.$set(this.formData, key, data[key]);
    });
    if (!this.formData.mobileNumbers || this.formData.mobileNumbers.length === 0) {
      this.formData.mobileNumbers = [''];
    }
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      if (this.isEdit) {
        await (0, _companies.updateCompany)(this.formData.id, this.formData);
      } else {
        await (0, _companies.createCompany)(this.formData);
      }
      this.$notify({
        title: 'Success',
        message: 'Company saved successfully',
        type: 'success'
      });
      this.$router.push({
        name: 'Companies'
      });
    } finally {
      this.loading = false;
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'CompanyDetail',
  components: {
    Cropper: _vueAdvancedCropper.Cropper,
    FileUpload: _index.default
  }
})], default_1);
var _default = exports.default = default_1;